import React, { useEffect } from 'react';
import { ConfigProvider } from 'antd';
import { Outlet } from 'react-router-dom';
import { printTheme } from "../../base-react/styles/theme";
export function Print() {
    useEffect(() => {
        const timeout = setTimeout(() => {
            document.body.style.backgroundColor = 'white';
            document.body.style.margin = '0px';
        }, 10);
        return () => clearTimeout(timeout);
    }, []);
    return (React.createElement(ConfigProvider, { theme: printTheme },
        React.createElement(Outlet, null)));
}
